"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import PropTypes from "prop-types";

import { shallowEqual, useSelector } from "react-redux";
import { COUNTRIES } from "../../../../constants/common/common";
import useAnalytics from "../../../../analytics/useAnalytics";
import { cleverTapCommonEvents } from "../../../../analytics/clevertapConstants";
import { pageName } from "../../../../utils/common";
import CustomImage from "../../../atoms/customImage";
import CookieUtil from "../../../../utils/storage/cookieUtil";
import { HDFC_SMARTBUY, PARTNER } from "../../../../constants/storage";
import { homePageConstants } from "../../../../constants/pageConstants/homeConstants";

/**
 * FNPIcon component represents the FNP (Ferns N Petals) icon.
 * Clicking on this icon redirects the user to the FNP homepage.
 * @returns {JSX.Element} The JSX representation of the FNPIcon component.
 */
const FNPIcon = ({ parentClasses = "w-[126px]", imgWidth = 126, imgHeight = 40, isShowLogoWithoutText = false }) => {
  const pathname = usePathname();
  const { trackEvent } = useAnalytics();
  const isHome = pathname === "/";
  const isPLP = pathname?.includes("-lp");
  const { product, catalogId } = useSelector(
    (state) => ({
      product: state?.pdp?.clientCurrentClickedItem,
      catalogId: state.appConfig.catalogId,
    }),
    shallowEqual,
  );
  const urlIdentifier = product?.urlIdentifier;
  const [isSmartBuyUser, setIsSmartBuyUser] = useState(false);

  useEffect(() => {
    setIsSmartBuyUser(CookieUtil.getCookie(PARTNER) === HDFC_SMARTBUY);
  }, []);

  const homeURL =
    catalogId === COUNTRIES.INDIA
      ? isSmartBuyUser
        ? `/${homePageConstants.SMART_BUY}`
        : "/"
      : `/${catalogId}/gifts-lp`;

  /**
   * Handles the click event on the FNP icon.
   * Redirects the user to the FNP homepage.
   */
  const onClick = () => {
    const pageHeaderMenuData = {
      page_name: pageName(isHome, isPLP, pathname, urlIdentifier),
      pageType: (typeof window !== "undefined" && window.fnpPageType) || "",
      menu_name: "FNP",
    };
    trackEvent(cleverTapCommonEvents.headerMenuClicked, pageHeaderMenuData, ["clevertap"]);
  };

  return (
    <a className={`cursor-pointer ${parentClasses}`} onClick={onClick} id="header_icon" href={homeURL}>
      <CustomImage
        src={isShowLogoWithoutText ? "/icons/fnp-logo-box.svg" : "/icons/fnp-gift-new.svg"}
        width={imgWidth}
        height={imgHeight}
        alt="Ferns N Petals"
        isPriority={false}
      />
    </a>
  );
};

FNPIcon.propTypes = {
  parentClasses: PropTypes.string,
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  isShowLogoWithoutText: PropTypes.bool,
};

export default FNPIcon;
